import Vue from 'vue';

Vue.filter('uppercase', (value) => {
    if (value) {
        value = value.toUpperCase();
    }

    return value;
});